import { attributes } from "@type-r/models";

export type Currency = InstanceType<typeof Currency>;

export const Currency = attributes({
    name: String,
    code: String
});